import React, { useState } from 'react';
import CompanyAutocomplete from './CompanyAutocomplete';

function InputForm({ onAnalyze, disabled }) {
  const [company, setCompany] = useState('');
  const [event, setEvent] = useState('');

  // Validate the TRIMMED length — matches what gets sent to the backend.
  // Without this, a string like "USA China " (10 chars w/ trailing space) would
  // pass UI validation but fail server-side as "USA China" (9 chars).
  const trimmedEvent = event.trim();
  const eventCharCount = trimmedEvent.length;
  const minEventChars = 10;
  const maxEventChars = 100;
  const isEventValid = eventCharCount >= minEventChars && eventCharCount <= maxEventChars;
  const isEventTooShort = eventCharCount > 0 && eventCharCount < minEventChars;
  const isEventTooLong = eventCharCount > maxEventChars;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (company.trim() && event.trim() && isEventValid) {
      onAnalyze(company.trim(), event.trim());
    }
  };

  return (
    <div 
      className="rounded-lg p-6 sm:p-8"
      style={{ backgroundColor: 'hsl(var(--gb-surface))' }}
    >
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Company Input with Autocomplete */}
          <div>
            <label 
              htmlFor="company"
              className="block text-sm font-medium mb-2"
              style={{ color: 'hsl(var(--gb-navy))' }}
            >
              Company or Ticker
            </label>
            <CompanyAutocomplete
              value={company}
              onChange={setCompany}
              disabled={disabled}
            />
          </div>

          {/* Event Input */}
          <div>
            <label 
              htmlFor="event"
              className="block text-sm font-medium mb-2"
              style={{ color: 'hsl(var(--gb-navy))' }}
            >
              Geopolitical Event
            </label>
            <textarea
              id="event"
              data-testid="event-input"
              value={event}
              onChange={(e) => setEvent(e.target.value)}
              placeholder="e.g., US-China strategic competition"
              disabled={disabled}
              required
              maxLength={100}
              rows={3}
              className="w-full px-4 py-3 rounded-lg text-sm resize-y leading-6"
              style={{
                backgroundColor: 'white',
                border: `2px solid ${isEventTooShort || isEventTooLong ? 'hsl(var(--gb-rust))' : 'hsl(var(--gb-gold))'}`,
                color: 'hsl(var(--gb-navy))',
                fontFamily: 'var(--font-body)',
                minHeight: '88px'
              }}
            />
            <div className="flex justify-between items-center mt-1 text-xs">
              <div style={{ color: isEventTooShort ? 'hsl(var(--gb-rust))' : 'hsl(var(--gb-text-muted))' }}>
                {isEventTooShort && `Need ${minEventChars - eventCharCount} more characters`}
                {isEventValid && 'Ready to analyze'}
                {eventCharCount === 0 && '10-100 characters required'}
              </div>
              <div style={{ color: isEventTooLong ? 'hsl(var(--gb-rust))' : 'hsl(var(--gb-text-muted))' }}>
                {eventCharCount}/{maxEventChars}
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="mt-6">
          <button
            type="submit"
            data-testid="run-analysis-button"
            disabled={disabled || !company.trim() || !isEventValid}
            className="w-full py-4 px-6 rounded-lg text-base font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              backgroundColor: 'hsl(var(--gb-navy))',
              color: 'hsl(var(--gb-primary-foreground))',
            }}
          >
            {disabled ? 'Analyzing...' : 'RUN ANALYSIS'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default InputForm;
